import React, { useState, useEffect } from 'react';
import MatchMember from '@/views/SiteService/components/MatchMember';
import { Member } from '@/views/SiteService';
import useRouter from '@/hooks/useRouter';
import Make from './Make';

const ReaplceMake = () => {
  const [member, setMember] = useState<Member>({});
  const { pathname } = useRouter();

  useEffect(() => {
    setMember(null);
  }, [pathname]);

  return (
    <div>
      <MatchMember member={member} setMember={setMember} onlyMatchMember />
      <Make member={member} />
    </div>
  );
};

export default ReaplceMake;
